'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = focusRing;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This is a decorator that ensures a focus-ring className set by the focus-ring-polyfill
 * is retained when a focused component is rendered following a state change.
*/
function focusRing(WrappedComponent) {
  var proto = WrappedComponent.prototype;
  var componentWillUpdate = proto.componentWillUpdate;
  var componentDidUpdate = proto.componentDidUpdate;

  var FOCUS_RING_CLASSNAME = 'focus-ring';
  var elementWithFocusRing = null;

  proto.componentWillUpdate = function (props, state) {
    // call original method
    if (componentWillUpdate) {
      componentWillUpdate.apply(this, arguments);
    }

    if (elementWithFocusRing == null || elementWithFocusRing !== document.activeElement) {
      try {
        var node = _reactDom2.default.findDOMNode(this);
        elementWithFocusRing = node.parentNode.querySelector('.' + FOCUS_RING_CLASSNAME);
      } catch (error) {
        // do nothing if component is not mounted
      }
    }
  };

  proto.componentDidUpdate = function (props, state) {
    // call original method
    if (componentDidUpdate) {
      componentDidUpdate.apply(this, arguments);
    }

    try {
      var node = _reactDom2.default.findDOMNode(this);
      if (elementWithFocusRing && (document.activeElement === elementWithFocusRing || node.contains(document.activeElement)) && !elementWithFocusRing.classList.contains(FOCUS_RING_CLASSNAME)) {
        document.activeElement.classList.add(FOCUS_RING_CLASSNAME);
        elementWithFocusRing = null;
      }
    } catch (error) {
      // do nothing if component is not mounted
    }
  };
}